import { TimelineSection } from '../section-listing.model';

/**
 * A LEAP v2 6-week Progress Report as a read-only timeline section (sectionType 'progress-report').
 * Serialized by the backend ProgressReportSection — rendered straight from the payload; the card links
 * to the specific report by `id`.
 */
export class ProgressReportTimelineSection extends TimelineSection {
  studentId: number;
  statusId?: number;
  submitted: boolean;
  approved: boolean;
  reportDate: string;
  assessmentScorePercentage?: number;
  confidenceRating?: number;
  resilienceRating?: number;
  independenceRating?: number;
  motivationRating?: number;
  selfRegulationRating?: number;
  last6WeeksSummary?: string;
  next6WeeksPlan?: string;
}
